import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=bac1be2e&"
import script from "./MenuBar.vue?vue&type=script&lang=ts&"
export * from "./MenuBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeaderMenuDesktop: require('/app/components/app/header/MenuDesktop.vue').default})
